import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "./index.css";
import "../src/Lora-VariableFont_wght.ttf";
import "../src/Lora-Italic-VariableFont_wght.ttf";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Submarine from "./components/submarine";
import Gospel from "./components/gospel";
import Subscribe from "./components/subscribe";
import Media from "./components/media";
import Blog from "./components/media/blog";
import Essays from "./components/media/essays";
import Winwin from "./components/media/essays/winwin";
import ChristianTech from "./components/media/essays/christiantech";
import Symbols from "./components/media/essays/symbols";
import Photos from "./components/media/photos";
import IWK from "./components/media/iwk";
import About from "./components/about";
import Unfound from "./components/404";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <App />
    <Routes>
      <Route exact path="/" element={<Navigate to="/about" />} />
      <Route path="/about" element={<About />} />
      <Route path="/gospel" element={<Gospel />} />
      <Route path="/submarine" element={<Submarine />} />
      <Route path="/subscribe" element={<Subscribe />} />
      <Route path="/media" element={<Media />}>
        <Route path="blog" element={<Blog />} />
        <Route path="photos" element={<Photos />} />
        <Route path="iwk" element={<IWK />} />
        <Route path="essays" element={<Essays />}>
          <Route path="winwin" element={<Winwin />} />
          <Route path="christiantech" element={<ChristianTech />} />
          <Route path="symbols" element={<Symbols />} />
        </Route>
      </Route>
      <Route path="*" element={<Unfound />} />
    </Routes>
  </BrowserRouter >
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
